var accordion_ = {};

accordion_.init = function() {
	$('.accordion').each(function() {
		var $this = $(this);
		if (typeof jQuery.ui != 'undefined' && typeof jQuery.ui.accordion != 'undefined') {
			$this.accordion({
				active: false,
				heightStyle: "content",
				icons: false,
				collapsible: true
			});
		} else {
			$this.find('.answer').each(function() {
				$(this).show();
			});
		}
	});
}

export { accordion_ };
